<mat-card data-at-all-devices-modal>
  <mat-card-title>{{
    '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.TITLE' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col gap-[4px]">
    <div *ngIf="devices && devices.length" class="flex flex-col">
      <div class="header-row lt-md:!hidden flex flex-row">
        <div class="flex-[5%] max-w-[5%]">
          <!-- Connection status space -->
        </div>
        <div class="flex-[25%] max-w-[25%]">
          <span>{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.NAME' | translate }}</span>
        </div>
        <div class="flex-[15%] max-w-[15%]">
          <span>{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.ROOM' | translate }}</span>
        </div>
        <div class="flex-[10%] max-w-[10%]">
          <span>{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.SIGNAL' | translate }}</span>
        </div>
        <div class="flex-[10%] max-w-[10%]">
          <span>{{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.BATTERY' | translate }}</span>
        </div>
        <div class="flex-[15%] max-w-[15%]">
          <span>{{
            '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.HEATING_CIRCUIT' | translate
          }}</span>
        </div>
        <div class="flex-[10%] max-w-[10%]" *ngIf="gatewayStore.hasAnyFHTDemandRelayMode$ | async">
          <span>{{
            '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.FHT_DEMAND_RELAY_MODE' | translate
          }}</span>
        </div>
        <div class="flex-[10%] max-w-[10%]">
          <!-- Space for mounting mode icon + delete icon-->
        </div>
      </div>
      <ng-container *ngTemplateOutlet="deviceItems"> </ng-container>
      <ng-template #deviceItems>
        <ng-container *ngFor="let device of devices">
          <div class="devices-container">
            <app-added-device-item [device]="device" [devices]="devices"></app-added-device-item>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-all-devices-modal-btn-close
      mat-button
      gtm="onClose"
      gtmCategory="allAddedDevices"
      color="primary"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
    <button
      data-at-all-devices-modal-btn-add-device
      mat-raised-button
      gtm="onOpen"
      gtmAction="Add device dialog"
      gtmCategory="allAddedDevices"
      color="primary"
      (click)="onAddDevice()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.COMMISSIONING.ADD_DEVICE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
